const openToValues = [
    'Any Collaboration',
    'Remote Collaboration',
    'Local Collaboration',
    'Making New Connections',
    'Discovering New Music',
    'Joining a Band',
    'Starting a Band',
];

const seekingValues = [
    'Accordionist',
    'Actor',
    'Agent',
    'Audio Engineer',
    'Backing Singer',
    'Banjoist',
    'Bassist',
    'Beatmaker',
    'Blogger',
    'Cellist',
    'Clarinetist',
    'Composer',
    'Conductor',
    'Dancer',
    'DJ',
    'Drum Tech',
    'Drummer',
    'Fine Artist',
    'Fluteist',
    'Ghostwriter',
    'Graphic Designer',
    'Guitarist',
    'Guitar Tech',
    'Harmonicist',
    'Harpist',
    'Keyboardist',
    'Lyricist',
    'Label',
    'Lighting Tech',
    'Live Artist',
    'Live Sound',
    'Manager',
    'Mandolinist',
    'Mastering Engineer',
    'Mixing Engineer',
    'Makeup Artist',
    'Music Director',
    'Music Teacher',
    'Oboist',
    'Percussionist',
    'Pianist',
    'Podcaster',
    'Producer',
    'Promoter',
    'Publicist',
    'Rapper',
    'Saxophonist',
    'Singer',
    'Songwriter',
    'Sound Designer',
    'Studio Engineer',
    'Trombonist',
    'Trumpeter',
    'Ukulelist',
    'Videographer',
    'Video Editor',
    'Violinist',
    'Vocalist',
    'Woodwindist',
];

const offeringValues = [
    'Accordionist',
    'Actor',
    'Agent',
    'Audio Engineer',
    'Backing Singer',
    'Banjoist',
    'Bassist',
    'Beatmaker',
    'Blogger',
    'Cellist',
    'Clarinetist',
    'Composer',
    'Conductor',
    'Dancer',
    'DJ',
    'Drum Tech',
    'Drummer',
    'Fine Artist',
    'Fluteist',
    'Ghostwriter',
    'Graphic Designer',
    'Guitarist',
    'Guitar Tech',
    'Harmonicist',
    'Harpist',
    'Keyboardist',
    'Lyricist',
    'Label',
    'Lighting Tech',
    'Live Artist',
    'Live Sound',
    'Manager',
    'Mandolinist',
    'Mastering Engineer',
    'Mixing Engineer',
    'Makeup Artist',
    'Music Director',
    'Music Teacher',
    'Oboist',
    'Percussionist',
    'Pianist',
    'Podcaster',
    'Producer',
    'Promoter',
    'Publicist',
    'Rapper',
    'Saxophonist',
    'Singer',
    'Songwriter',
    'Sound Designer',
    'Studio Engineer',
    'Trombonist',
    'Trumpeter',
    'Ukulelist',
    'Videographer',
    'Video Editor',
    'Violinist',
    'Vocalist',
    'Woodwindist',
];

export { openToValues, seekingValues, offeringValues };
